import React, { useState, useEffect } from "react";
import { Row, Col, Input, Form, Select } from "antd";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import {
  getAddressCountriesAPI,
  getAddressProvincesAPI,
} from "./Lookup/LookupAPI";

function Address(props) {
  const intl = useIntl();
  const dispatch = useDispatch();
  const selectedLanguage = localStorage.getItem("selectedlanguage") || "fr-FR";
  const addressProvinces = useSelector(
    (state) => state.lookup.addressProvinces
  );
  const addressCountries = useSelector(
    (state) => state.lookup.addressCountries
  );
  const handleInputChange = (field) => {
    props?.setIsFieldsEdited(true);
    if (props?.onChange) {
      if (props.onChange != "Company") {
        props.onChange(props?.prefix);
      }
    }
    if (field === "Company") {
      props?.setCompanyAddressId(props.addressId);
    } else if (field === "Billing") {
      props?.setBillingAddressId(props.addressId);
    }
  };
  useEffect(() => {
    dispatch(getAddressProvincesAPI());
    dispatch(getAddressCountriesAPI());
  }, []);
  return (
    <>
      <Row gutter={16}>
        <Col xs={24} sm={12} md={12} lg={12} xl={12}>
          <Form.Item label="AddressId" name={[props?.prefix, "id"]} hidden />
          <Form.Item
            label={<FormattedMessage id="Address.AddressLine1" />}
            name={[props?.prefix, "address1"]}
            rules={
              props?.isValidationRequired
                ? [
                    {
                      required: true,
                      message: intl.formatMessage({
                        id: "Address.Error.AddressLine1",
                      }),
                    },
                  ]
                : []
            }
          >
            <Input
              placeholder={intl.formatMessage({
                id: "Address.PlaceHolder.AddressLine1",
              })}
              maxLength={200}
              disabled={props?.disabled}
              onChange={handleInputChange}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={12} xl={12}>
          <Form.Item
            label={<FormattedMessage id="Address.AddressLine2" />}
            name={[props?.prefix, "address2"]}
          >
            <Input
              placeholder={intl.formatMessage({
                id: "Address.PlaceHolder.AddressLine2",
              })}
              maxLength={200}
              disabled={props?.disabled}
              onChange={handleInputChange}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={12} xl={12}>
          <Form.Item
            label={<FormattedMessage id="Address.City" />}
            name={[props?.prefix, "city"]}
            rules={
              props?.isValidationRequired
                ? [
                    {
                      required: true,
                      message: intl.formatMessage({ id: "Address.Error.City" }),
                    },
                  ]
                : []
            }
          >
            <Input
              placeholder={intl.formatMessage({
                id: "Address.PlaceHolder.City",
              })}
              maxLength={50}
              disabled={props?.disabled}
              onChange={handleInputChange}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={12} xl={12}>
          <Form.Item
            label={<FormattedMessage id="Lead.Province" />}
            name={[props?.prefix, "provinceId"]}
            rules={
              props?.isValidationRequired
                ? [
                    {
                      required: true,
                      message: intl.formatMessage({
                        id: "Address.Error.State",
                      }),
                    },
                  ]
                : []
            }
            initialValue={props?.isValidationRequired ? 9 : undefined}
          >
            <Select
              showSearch
              placeholder={intl.formatMessage({
                id: "Address.PlaceHolder.State",
              })}
              disabled={props?.disabled}
              onChange={handleInputChange}
              optionFilterProp="children"
              allowClear
            >
              {addressProvinces?.map((province) => (
                <Select.Option key={province.id} value={province.id}>
                  {selectedLanguage.startsWith("fr")
                    ? province.provinceNameFr
                    : province.provinceNameEn}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={12} xl={12}>
          <Form.Item
            label={<FormattedMessage id="Address.PostalCode" />}
            name={[props?.prefix, "zip"]}
            rules={
              props?.isValidationRequired
                ? [
                    {
                      required: true,
                      message: intl.formatMessage({
                        id: "Address.Error.PostalCode",
                      }),
                    },
                    {
                      pattern: /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/,
                      message: intl.formatMessage({
                        id: "Lead.Error.InvalidPostalCode",
                      }),
                    },
                  ]
                : [
                    {
                      pattern: /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/,
                      message: intl.formatMessage({
                        id: "Lead.Error.InvalidPostalCode",
                      }),
                    },
                  ]
            }
          >
            <Input
              placeholder={intl.formatMessage({
                id: "Address.PlaceHolder.PostalCode",
              })}
              maxLength={50}
              disabled={props?.disabled}
              onChange={handleInputChange}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={12} xl={12}>
          <Form.Item
            label={<FormattedMessage id="Address.Country" />}
            name={[props?.prefix, "countryId"]}
            rules={
              props?.isValidationRequired
                ? [
                    {
                      required: true,
                      message: intl.formatMessage({
                        id: "Address.Error.Country",
                      }),
                    },
                  ]
                : []
            }
            initialValue={props?.isValidationRequired ? 1 : undefined}
          >
            <Select
              showSearch
              placeholder={intl.formatMessage({
                id: "Address.PlaceHolder.Country",
              })}
              disabled={props?.disabled}
              onChange={handleInputChange}
              optionFilterProp="children"
              allowClear
            >
              {addressCountries?.map((country) => (
                <Select.Option key={country.id} value={country.id}>
                  {selectedLanguage.startsWith("fr")
                    ? country.countryNameFr
                    : country.countryNameEn}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
    </>
  );
}

export default Address;
